
import {CollaboratorRole} from 'src/openapi/admin/models/CollaboratorRole';
import {WorkspaceRequest} from 'src/openapi/admin/models/WorkspaceRequest';

export enum WorkspaceOwnershipFilter {
    ALL = 'ALL',
    USER = 'USER',
    SHARED = 'SHARED',
}

export const WorkspaceOwnershipFilterLabel: Record<WorkspaceOwnershipFilter, string> = {
    [WorkspaceOwnershipFilter.ALL]: 'All Workspaces',
    [WorkspaceOwnershipFilter.SHARED]: 'Shared with user',
    [WorkspaceOwnershipFilter.USER]: 'User workspaces',
};

export function mapWorkspaceOwnershipFilterToCollaboratorRoles(
    filter: WorkspaceOwnershipFilter,
): CollaboratorRole[] {
    switch (filter) {
        case WorkspaceOwnershipFilter.USER:
            return [CollaboratorRole.OWNER];
        case WorkspaceOwnershipFilter.SHARED:
            return [CollaboratorRole.EDITOR, CollaboratorRole.VIEWER];
        case WorkspaceOwnershipFilter.ALL:
        default:
            return [CollaboratorRole.VIEWER, CollaboratorRole.EDITOR, CollaboratorRole.OWNER];
    }
}

export function collaboratorRolesToOwnership(
    roles: ReadonlyArray<CollaboratorRole> = [],
): WorkspaceOwnershipFilter {
    const set = new Set(roles);

    if (set.has(CollaboratorRole.OWNER) && set.size === 1) {
        return WorkspaceOwnershipFilter.USER;
    }
    if (set.has(CollaboratorRole.OWNER) && (set.has(CollaboratorRole.EDITOR) || set.has(CollaboratorRole.VIEWER))) {
        return WorkspaceOwnershipFilter.ALL;
    }
    if (set.has(CollaboratorRole.EDITOR) || set.has(CollaboratorRole.VIEWER)) {
        return WorkspaceOwnershipFilter.SHARED;
    }
    return WorkspaceOwnershipFilter.ALL;
}

export const SCOPE_KEY = 'content-workspace';

export function makeWorkspaceQueryKey(userId: number, request: WorkspaceRequest): string {
    const stableRequest = {
        ...request,
        ownerFilter: [...request.ownerFilter].sort(),
    };

    return `${userId}::${JSON.stringify(stableRequest)}`;
}
